import styles from './WarrantyReturnsParagraph.module.scss';

interface WarrantyReturnsParagraphProps {
  children: React.ReactNode;
  className?: string;
}

export const WarrantyReturnsParagraph = ({
  children,
  className,
}: WarrantyReturnsParagraphProps) => (
  <p className={`${styles['warrantyReturns__description-p']} ${className}`}>
    {children}
  </p>
);
